import { useEffect, useState } from 'react';
import { AnimatePresence, m } from 'framer-motion';
// @mui
import { alpha } from '@mui/material/styles';
import Box, { BoxProps } from '@mui/material/Box';
//
import SvgColor from '../svg-color';

// ----------------------------------------------------------------------

const ICONS = [
  '/assets/icons/company/ri--openai-fill.svg',
  '/assets/icons/company/ri--anthropic-line.svg',
  '/assets/icons/company/mingcute--google-fill.svg',
  '/assets/icons/company/hugeicons--qwen.svg',
];

export default function SplashScreen({ sx, ...other }: BoxProps) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const t = setInterval(() => {
      setIndex((prev) => (prev + 1) % ICONS.length);
    }, 1200);

    return () => clearInterval(t);
  }, []);

  const currentSrc = ICONS[index];

  return (
    <Box
      sx={{
        right: 0,
        width: 1,
        bottom: 0,
        height: 1,
        zIndex: 9998,
        display: 'flex',
        position: 'fixed',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
        ...sx,
      }}
      {...other}
    >
      <>
        <AnimatePresence mode="wait">
          <m.div
            key={currentSrc}
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{
              opacity: [1, 0.48, 0.48, 1, 1],
              scale: [1, 0.9, 0.9, 1, 1],
            }}
            exit={{ opacity: 0, scale: 0.9 }}
            transition={{
              duration: 1,
              ease: 'easeInOut',
            }}
          >
            <SvgColor src={currentSrc} sx={{ width: 40, height: 40 }} />
          </m.div>
        </AnimatePresence>

        <Box
          component={m.div}
          animate={{
            scale: [1.6, 1, 1, 1.6, 1.6],
            rotate: [270, 0, 0, 270, 270],
            opacity: [0.25, 1, 1, 1, 0.25],
            borderRadius: ['25%', '25%', '50%', '50%', '25%'],
          }}
          transition={{ ease: 'linear', duration: 3.2, repeat: Infinity }}
          sx={{
            width: 100,
            height: 100,
            position: 'absolute',
            border: (theme) => `solid 3px ${alpha(theme.palette.primary.main, 0.24)}`,
          }}
        />

        <Box
          component={m.div}
          animate={{
            scale: [1, 1.2, 1.2, 1, 1],
            rotate: [0, 270, 270, 0, 0],
            opacity: [1, 0.25, 0.25, 0.25, 1],
            borderRadius: ['25%', '25%', '50%', '50%', '25%'],
          }}
          transition={{ ease: 'linear', duration: 3.2, repeat: Infinity }}
          sx={{
            width: 120,
            height: 120,
            position: 'absolute',
            border: (theme) => `solid 8px ${alpha(theme.palette.primary.main, 0.24)}`,
          }}
        />
      </>
    </Box>
  );
}
